module.exports = __webpack_public_path__ + "static/media/logo-ddg.343346a0.jpg";